import MovieDetailPage from "./MovieDetailPage";
export default MovieDetailPage;
